<template>
  <div class="addresses--edit-address d-inline pull-left">
    <b-button v-if="!hideAddButton" @click="newAddress" ref="btnShow" size="sm" variant="primary" title="Add New">
      <i class="fa fa-plus" aria-hidden="true"></i>
      Add New
    </b-button>
    <b-modal
      id="edit-address-modal"
      ref="editAddressModal"
      size="xl"
      :title="modalTitle"
      @shown="initializeModal"
      @hidden="hideModal"
      :ok-title="isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
      scrollable
    >
      <b-row>
        <b-col cols="6">
          <b-row>
            <b-col>
              <b-form-group label="Type">
                <b-form-select
                  id="addressType"
                  v-model="currentTypeId"
                  :plain="true"
                  @change="onAddressTypeChange"
                >
                  <option
                    v-for="(type) in sortSelect(addressTypes)"
                    v-bind:key="type.id"
                    v-bind:value="type.id"
                  >{{type.name}}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-checkbox
                id="is-default"
                v-model="address.isDefault"
                aria-describedby="input1LiveFeedback7"
                style="margin-top:15px"
              >Is Default</b-form-checkbox>
            </b-col>
          </b-row>

          <b-form-group>
            <b-form-group class="required address-name" label="Address Name">
              <b-form-input v-model.trim="address.name" :placeholder="company.name"
              ></b-form-input>
              <!-- <b-form-invalid-feedback>Address Name is required</b-form-invalid-feedback> -->
            </b-form-group>
          </b-form-group>

          <b-form-group label="Contact Name">
            <!-- <b-form-input type="text" id="name" v-model="address.contactName"></b-form-input> -->
            <b-form-select v-model="address.contactId" @change="onContactChange">
              <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
                {{ select.firstName + ' ' + select.lastName }}</option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Phone Number">
            <b-form-input type="text" id="phoneNumber" v-model="address.phone"></b-form-input>
          </b-form-group>

          <b-form-group label="Fax Number">
            <b-form-input type="text" id="faxNumber" v-model="address.fax"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Address 1">
            <b-form-input type="text" id="address1" v-model="address.address1"></b-form-input>
          </b-form-group>

          <b-form-group label="Address 2">
            <b-form-input type="text" id="address2" v-model="address.address2"></b-form-input>
          </b-form-group>

          <b-form-group label="Address 3">
            <b-form-input type="text" id="address3" v-model="address.address3"></b-form-input>
          </b-form-group>

          <b-row>
            <b-col cols="4">
              <b-form-group label="City">
                <b-form-input type="text" id="city" v-model="address.city"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group label="State / Province">
                <b-form-input type="text" id="state" v-model="address.state"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group label="Postal Code">
                <b-form-input type="text" id="zipcode" v-model="address.zipCode"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group label="Country">
            <b-form-select id="country" v-model="address.countryCode">
              <option
                v-for="(countryCode) in sortSelect(countryCodesDetailed,'country')"
                v-bind:key="countryCode.code2"
                v-bind:value="countryCode.code2"
              >{{countryCode.country}}</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button @click="$bvModal.hide('edit-address-modal')">
          Cancel
        </b-button>
        <b-button variant="warning" v-if="address.id" @click="copyAddress" :disabled="isSaving">
          Copy
        </b-button>
        <b-button @click="saveAddress" variant="primary" :disabled="isSaving">
          {{ isSaving ? 'Saving...' : 'Save' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  props: [
    'companyId',
    'id',
    'hideAddButton'
  ],
  data() {
    return {
      address: {
        name: '',
      },
      currentTypeId: 1,
      isSaving: false,
      isCopied: false
    }
  },
  validations: {
    address: {
      // name: { required },
    },
  },
  computed: {
    ...mapGetters('lookup', ['addressTypes','countryCodesDetailed']),
    ...mapGetters('companies', ['companyById']),
    ...mapGetters('quoteDetails', [ 'contacts' ]),
    modalTitle() {
      return this.address && this.address.id ? 'Edit address' : 'New address';
    },
    company() {
      return this.companyById(this.companyId);
    },
  },
  methods: {
    ...mapActions('address', [
      'getAddresses',
      'getAddressById',
      /*'addNewAddress',
      'editAddress',*/
      'manage',
    ]),
    async initializeModal() {
      this.$v.address.$reset();
      if (this.id) {
        this.address = await await this.getAddressById(this.id);
        this.currentTypeId = this.address.addressTypeId;
      } else {
        this.currentTypeId = 1;
      }
    },
    hideModal() {
      this.$emit('hideModal');
    },
    newAddress() {
      this.address = {
        name: this.company.name,
        phone: this.company.phone1,
        fax: this.company.fax1,
        accountId: this.companyId
      };
      // this.address.accountId = this.companyId;
      this.show();
    },
    show() {
      this.$v.$reset();
      this.$refs.editAddressModal.show();
    },
    onContactChange() {
        const contact = this.contacts.find(x => x.id == this.address.contactId);
        this.address.contactName = (contact) ? contact.firstName + ' ' + contact.lastName : '';
        this.address.phone = (contact) ? contact.phone1 : this.company.phone1;
      },
    setDefaultFromCompany() {
        if (this.address.name == '' || this.address.name == null) this.address.name = this.company.name;
        if (this.address.phone == '' || this.address.phone == null) this.address.phone = this.company.phone1;
        if (this.address.fax == ''  || this.address.fax == null) this.address.fax = this.company.fax1;
      },
    async copyAddress() {
      try {
        this.isSaving = true;
        this.address = {...this.address, id: 0, isDefault: false};
        /*this.address = await this.addNewAddress(this.address);*/
        this.address = await this.manage(this.address);
        this.isSaving = false;
        this.isCopied = true;
        // this.$bvModal.hide('edit-address-modal');
        // await this.getAddresses(this.companyId);
        this.$emit('saved');
        this.$snotify.success('Address Copied', 'Company Address');
      }catch (e) {
        this.isSaving = false;
        this.isCopied = false;
      }
    },
    async saveAddress(e) {
      this.$v.address.$touch();
      if (this.$v.address.$invalid) {
        e.preventDefault();
        return;
      }
      try {
        this.isSaving = true;
        this.address.accountId = this.companyId;
        this.address.addressTypeId = this.currentTypeId;
        this.setDefaultFromCompany();
        /*if (!this.id) {
          this.address.id = 0;
          await this.addNewAddress(this.address);
        } else {
          await this.editAddress(this.address);
        }*/
        await this.manage(this.address);
        this.isSaving = false;
        this.$bvModal.hide('edit-address-modal');
        // await this.getAddresses(this.companyId);
        this.$emit('saved');
        this.$snotify.success('Address Saved', 'Company Address');
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    onAddressTypeChange(value) {
      if (value == 1 || this.address.addressTypeId == 1) {
        this.currentTypeId = value;

        return;
      }

      if (this.address.isDefault) {
        this.openAlertBox({message: "You can't change type of this address due this is an default address"});
        this.currentTypeId = this.address.addressTypeId;

        return;
      }
    },
  },
}
</script>

<style lang="scss">
.address-name {
  margin-bottom: 0px;
}

// #edit-address-modal .modal-dialog {
//   width: 650px;
// }
</style>
